/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFormLayoutJet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 16v6H2v-6zm11-7v13h-9V9zM9 18H4v2h5zm11-7h-5v9h5zm-9-2v6H2V9zm-2 2H4v2h5zm2-9v6H2V2zm11 0v6h-9V2zM9 4H4v2h5zm11 0h-5v2h5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFormLayoutJet as FormLayoutJet };
